import { AsyncPipe, CommonModule, NgFor } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxPermissionsModule } from 'ngx-permissions';

import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';

import { MatNativeDateModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BaseChartDirective } from 'ng2-charts';
import { FooterComponent } from './portal-layout/footer/footer.component';

// custom pipes
import { PhoneNumberPipe } from './custom-pipes/phone-number.pipe';
import { PluralizePipe } from './custom-pipes/pluralize.pipe';
import { PositiveNumberPipe } from './custom-pipes/positive-number.pipe';
import { SearchFilterPipe } from './custom-pipes/search-filter.pipe';

// components
import { AccessDeniedComponent } from '../core/access-denied/access-denied.component';
import * as fromComponents from './components';
import { AutofocusDirective } from './directives/autofocus.directive';
import { TooltipDirective } from './directives/tooltip.directive';
import { HeaderComponent } from './portal-layout/header/header.component';
import { MobileNavPanelComponent } from './portal-layout/header/mobile-nav-panel/mobile-nav-panel.component';
import { NavigationRecordComponent } from './portal-layout/header/navigation-record/navigation-record.component';

// analytics
import * as fromAnalytics from './analytics';
import { ToggleComponent } from './components/toggle/toggle.component';
import { AccountSwitcherComponent } from './components/account-switcher/account-switcher.component';

@NgModule({
  imports: [
    FooterComponent,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPermissionsModule.forChild(),
    MatProgressSpinnerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatRadioModule,
    MatSelectModule,
    MatButtonModule,
    MatDatepickerModule,
    MatProgressBarModule,
    MatNativeDateModule,
    NgFor,
    AsyncPipe,
    MatMenuModule,
    NgApexchartsModule,
    PluralizePipe,
    NavigationRecordComponent,
    BaseChartDirective,
    MatDividerModule,
    ToggleComponent,
    AutofocusDirective,
    AccountSwitcherComponent,
    ...fromComponents.standaloneComponents,
  ],

  exports: [
    FooterComponent,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPermissionsModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatButtonModule,
    MatDatepickerModule,
    MatProgressBarModule,
    MatNativeDateModule,
    MatIconModule,
    BaseChartDirective,
    MatDividerModule,
    HeaderComponent,
    AccessDeniedComponent,
    ...fromComponents.components,
    ...fromComponents.standaloneComponents,
    TooltipDirective,
    AutofocusDirective,
    ...fromAnalytics.components,

    PositiveNumberPipe,
    PhoneNumberPipe,
    SearchFilterPipe,
    PluralizePipe,
  ],
  declarations: [
    ...fromComponents.components,
    ...fromAnalytics.components,
    HeaderComponent,
    MobileNavPanelComponent,
    PositiveNumberPipe,
    PhoneNumberPipe,
    TooltipDirective,
    SearchFilterPipe,
  ],
  providers: [
    PositiveNumberPipe,
    PhoneNumberPipe,
    SearchFilterPipe,
    PluralizePipe,
  ],
})
export class SharedModule {}
